<div id="orAdministrationGateways">
  @if (isLoading()) {
    <div class="loading-overlay">
      <mat-spinner />
    </div>
  }
  @if (!isBusy) {
    <div class="or-content-body">
      <div class="or-gateways-list">
        @for(gateway of gateways$ | async; track gateway.id) {
          <div class="or-gateways-list-item">
            <app-form-gateway-details
              [isNew]="false"
              [isBusy]="isGatewayListBusy"
              [gateway]="gateway"
              [afterUpdate$]="afterUpdate$"
              [error$]="onError$"
              [onGatewayReset$]="onGatewayReset$"

              (addGateway)="onAddGateway($event)"
              (updateGateway)="onUpdateGateway($event)"
              (getGatewaySnap)="getGatewaySnap($event)"
              (compareGatewayStates)="onCompareGateways($event)"
              (deleteGateway)="deleteGateway($event)"
              (generateKeys)="generateKeys($event)"
              (restartGateway)="restartGateway($event)"
              (resetGateway)="resetGateway($event)"
              (gatewayMigration)="onGatewayMigration($event)"
            >
            </app-form-gateway-details>
          </div>
        }
      </div>
      <div class="or-gateways-list">
        @if (newGatewayDetails != null) {
          <div class="or-gateways-list-item">
            <div class="or-form-header">
              <h2 class="or-form-title">New Gateway</h2>
            </div>
            <app-form-gateway-details
              [isNew]="true"
              [isBusy]="isGatewayListBusy"
              [gateway]="newGatewayDetails"
              [afterUpdate$]="afterUpdate$"
              [error$]="onError$"
              [onGatewayReset$]="onGatewayReset$"

              (addGateway)="onAddGateway($event)"
              (deleteGateway)="deleteGateway($event)"
              (generateKeys)="generateKeys($event)"
              (restartGateway)="restartGateway($event)"
              (resetGateway)="resetGateway($event)"
            >
            </app-form-gateway-details>
          </div>
        }
      </div>
      <button
        mat-raised-button
        color='primary'
        (click)="export()"
        type="button"
        data-cy='export-report'>
        <span class='or-icon or-small or-inverse or-icon-report'></span>
        <span class='or-button-label'>Extract Gateway Report</span>
      </button>
    </div>
  }
</div>
